// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyView_emptyContainer__mVMAN","emptyText":"EmptyView_emptyText__5XfS+"};